// extracted by mini-css-extract-plugin
module.exports = {"aboutname":"About_aboutname__Um2s0","input":"About_input__26mFg","connectform":"About_connectform__38im8","message":"About_message__3CX8D","sendbtn":"About_sendbtn__aJUaZ"};